import { BcfImportStep } from './interfaces/IBcfImportState';

export enum BcfImportActionKeys {
  // Step 1: File Upload
  UPLOAD_BCF_FILE = 'BCF_UPLOAD_BCF_FILE',
  ANALYZE_BCF_FILE_REQUEST = 'BCF_ANALYZE_BCF_FILE_REQUEST',
  ANALYZE_BCF_FILE_SUCCESS = 'BCF_ANALYZE_BCF_FILE_SUCCESS',
  ANALYZE_BCF_FILE_FAILED = 'BCF_ANALYZE_BCF_FILE_FAILED',

  // Step 2: Data Mapping
  UPDATE_FIELD_MAPPING = 'BCF_UPDATE_FIELD_MAPPING',
  FETCH_MAPPING_DEFAULTS_REQUEST = 'BCF_FETCH_MAPPING_DEFAULTS_REQUEST',
  FETCH_MAPPING_DEFAULTS_SUCCESS = 'BCF_FETCH_MAPPING_DEFAULTS_SUCCESS',
  FETCH_MAPPING_DEFAULTS_FAILED = 'BCF_FETCH_MAPPING_DEFAULTS_FAILED',
  VALIDATE_MAPPING_REQUEST = 'BCF_VALIDATE_MAPPING_REQUEST',
  VALIDATE_MAPPING_SUCCESS = 'BCF_VALIDATE_MAPPING_SUCCESS',

  // Step 3: Settings
  UPDATE_IMPORT_SETTINGS = 'BCF_UPDATE_IMPORT_SETTINGS',

  // Step 4: Summary
  GENERATE_PREVIEW_REQUEST = 'BCF_GENERATE_PREVIEW_REQUEST',
  GENERATE_PREVIEW_SUCCESS = 'BCF_GENERATE_PREVIEW_SUCCESS',
  GENERATE_PREVIEW_FAILED = 'BCF_GENERATE_PREVIEW_FAILED',

  // Navigation
  SET_CURRENT_STEP = 'BCF_SET_CURRENT_STEP',
  VALIDATE_AND_ADVANCE = 'BCF_VALIDATE_AND_ADVANCE',
  GO_BACK = 'BCF_GO_BACK',

  // Step 5: Execute
  EXECUTE_IMPORT_REQUEST = 'BCF_EXECUTE_IMPORT_REQUEST',
  EXECUTE_IMPORT_SUCCESS = 'BCF_EXECUTE_IMPORT_SUCCESS',
  EXECUTE_IMPORT_FAILED = 'BCF_EXECUTE_IMPORT_FAILED',
  UPDATE_IMPORT_PROGRESS = 'BCF_UPDATE_IMPORT_PROGRESS',

  // General
  RESET_IMPORT_STATE = 'BCF_RESET_IMPORT_STATE',
  SET_ERROR = 'BCF_SET_ERROR',
  CLEAR_ERROR = 'BCF_CLEAR_ERROR',
}

const createAction = (type: string, payload?: any) => ({ type, payload });

export const BcfImportActions = {
  // File Upload
  uploadFile: (file: File) => createAction(BcfImportActionKeys.UPLOAD_BCF_FILE, file),

  analyzeFile: (file: File) => createAction(BcfImportActionKeys.ANALYZE_BCF_FILE_REQUEST, file),
  analyzeFileSuccess: (result: any) =>
    createAction(BcfImportActionKeys.ANALYZE_BCF_FILE_SUCCESS, result),
  analyzeFileFailure: (error: string) =>
    createAction(BcfImportActionKeys.ANALYZE_BCF_FILE_FAILED, error),

  // Data Mapping
  updateFieldMapping: (fieldType: string, mapping: any) =>
    createAction(BcfImportActionKeys.UPDATE_FIELD_MAPPING, { fieldType, mapping }),

  fetchMappingDefaults: (constructionSiteId: string | number) =>
    createAction(BcfImportActionKeys.FETCH_MAPPING_DEFAULTS_REQUEST, constructionSiteId),
  fetchMappingDefaultsSuccess: (defaults: any) =>
    createAction(BcfImportActionKeys.FETCH_MAPPING_DEFAULTS_SUCCESS, defaults),
  fetchMappingDefaultsFailure: (error: string) =>
    createAction(BcfImportActionKeys.FETCH_MAPPING_DEFAULTS_FAILED, error),

  validateMapping: () => createAction(BcfImportActionKeys.VALIDATE_MAPPING_REQUEST),
  validateMappingSuccess: () => createAction(BcfImportActionKeys.VALIDATE_MAPPING_SUCCESS),

  // Settings
  updateImportSettings: (settings: any) =>
    createAction(BcfImportActionKeys.UPDATE_IMPORT_SETTINGS, settings),

  // Summary
  generatePreview: () => createAction(BcfImportActionKeys.GENERATE_PREVIEW_REQUEST),
  generatePreviewSuccess: (preview: any) =>
    createAction(BcfImportActionKeys.GENERATE_PREVIEW_SUCCESS, preview),
  generatePreviewFailure: (error: string) =>
    createAction(BcfImportActionKeys.GENERATE_PREVIEW_FAILED, error),

  // Navigation
  setCurrentStep: (step: BcfImportStep) =>
    createAction(BcfImportActionKeys.SET_CURRENT_STEP, step),

  validateAndAdvance: (currentStep: BcfImportStep) =>
    createAction(BcfImportActionKeys.VALIDATE_AND_ADVANCE, currentStep),

  goBack: () => createAction(BcfImportActionKeys.GO_BACK),

  // Execute Import
  executeImport: (constructionSiteId: string | number) =>
    createAction(BcfImportActionKeys.EXECUTE_IMPORT_REQUEST, constructionSiteId),
  executeImportSuccess: (result: any) =>
    createAction(BcfImportActionKeys.EXECUTE_IMPORT_SUCCESS, result),
  executeImportFailure: (error: string) =>
    createAction(BcfImportActionKeys.EXECUTE_IMPORT_FAILED, error),
  updateImportProgress: (progress: number) =>
    createAction(BcfImportActionKeys.UPDATE_IMPORT_PROGRESS, progress),

  // General
  resetImportState: () => createAction(BcfImportActionKeys.RESET_IMPORT_STATE),
  setError: (error: string) => createAction(BcfImportActionKeys.SET_ERROR, error),
  clearError: () => createAction(BcfImportActionKeys.CLEAR_ERROR),
};
